(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["page"]) return;
  try {
    
  if (!customElements.get('yuumae-page-content')) {
    customElements.define('yuumae-page-content', class extends HTMLElement {
      connectedCallback() {
        this.querySelectorAll('table').forEach((table, index) => {
          if (table.parentElement.classList.contains('yuumae-page-table')) return;
          const wrapper = document.createElement('div');
          wrapper.className = 'yuumae-page-table';
          wrapper.tabIndex = 0;
          wrapper.setAttribute('role', 'region');
          if (table.caption && !table.caption.id) table.caption.id = `${this.dataset.headingId}-table-${index}`;
          wrapper.setAttribute('aria-labelledby', table.caption?.id || this.dataset.headingId);
          table.before(wrapper);
          wrapper.append(table);
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yuumae-faq"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('yuumae-faq-page')) {
    customElements.define('yuumae-faq-page', class extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        const { signal } = this.abort;
        const index = this.querySelector('.yuumae-faq-index');
        const mobile = matchMedia('(max-width: 767px)');
        const setIndex = () => { index.open = !mobile.matches; };
        setIndex();
        mobile.addEventListener('change', setIndex, { signal });
        const links = [...this.querySelectorAll('[data-faq-link]')];
        const select = id => links.forEach(link => {
          if (link.hash === `#${id}`) link.setAttribute('aria-current', 'location');
          else link.removeAttribute('aria-current');
        });
        links.forEach(link => link.addEventListener('click', () => {
          if (mobile.matches) index.open = false;
          const category = document.getElementById(link.hash.slice(1));
          category?.focus({ preventScroll: true });
          select(category?.id);
        }, { signal }));
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            const visible = entries.filter(entry => entry.isIntersecting).sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);
            if (visible.length) select(visible[0].target.id);
          }, { rootMargin: '-15% 0px -60% 0px', threshold: 0 });
          this.querySelectorAll('.yuumae-faq-category').forEach(category => this.observer.observe(category));
        }
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
